import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { themes } from 'Components/widgets/alternative-proposals/alternative-price/AlternativePrice.themes';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  children: React.ReactNode;
  className?: string;
  iconName: IconName;
  onClick?: () => void;
  theme?: keyof typeof themes;
};
export const AlternativePriceCriteriaButton = ({
  children,
  className,
  iconName,
  onClick,
  theme = 'default',
}: Props) => {
  const { thButton, thIcon, thLabel } = themes[theme];
  return (
    <button className={classnames(thButton, className)} onClick={onClick} type="button">
      <Icon className={thIcon} name={iconName} width="1em" />
      <span className={thLabel}>{children}</span>
    </button>
  );
};
